type IconProps = {
  onClick?: (arg) => void,
  children?: any,
  color?: string,
  size?: string | number,
  icon?: string,
  className?: string,
  id?: string,
  dataAttr?:string,
};

export const Icon = ({ color="#000", size = "100%", icon="", className = "", id = "", children, onClick, dataAttr =''}: IconProps) => {
  return (
    <button onClick={onClick}
      className={className}
      id={id}
      title={icon}
      data-attr={dataAttr}
      style={{color}}
    >{children}</button>
  );
}

export default Icon;

